// src/pages/LandingPage.tsx
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import Button from "../components/ui/Button";

// export default function LandingPage() {
//   const navigate = useNavigate();

//   function go(pathId: string) {
//     navigate(`/register?path=${encodeURIComponent(pathId)}`);
//   }

//   return (
//     <div className="space-y-4">
//       <header className="rounded-xl bg-white p-4 ring-1 ring-slate-200">
//         <h1 className="text-xl font-bold">Calimesa VBS Registration</h1>
//         <p className="mt-1 text-sm text-slate-600">
//           Choose your registration path to get started.
//         </p>
//       </header>

//       <div className="rounded-xl bg-white p-4 ring-1 ring-slate-200 space-y-3">
//         <Button className="w-full" variant="secondary" onClick={() => go("parentChild")}>
//           Register My Child
//         </Button>
//         <Button className="w-full" variant="secondary" onClick={() => go("volunteerAndChild")}>
//           Volunteer & Register a Child
//         </Button>
//         <Button className="w-full" variant="secondary" onClick={() => go("volunteerOnly")}>
//           Volunteer Only
//         </Button>
//       </div>

//       <p className="text-xs text-slate-500">
//         Designed for quick phone registration.
//       </p>
//     </div>
//   );
// }

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/ui/Button";
import ArchSprite from "../components/ui/ArchSprite";
import { vbsSchedule } from "../constants/vbsSchedule";

// Change to true when you want volunteer buttons to work again
const VOLUNTEER_REGISTRATION_OPEN = false;

// Change to true when registration opens for the next year
const REGISTRATION_OPEN = false;

export default function LandingPage() {
  const navigate = useNavigate();
  const [volunteerMessage, setVolunteerMessage] = useState("");

  const currentDate = new Date();
  const cutoffDate = new Date("2026-07-12T00:00:00");
  const isAfterCutoff = currentDate >= cutoffDate;

  function go(pathId: string) {
    navigate(`/register?path=${encodeURIComponent(pathId)}`);
  }

  function handleVolunteerClick(pathId: string) {
    if (!VOLUNTEER_REGISTRATION_OPEN) {
      setVolunteerMessage(
        "Thank you for your interest in volunteering! Volunteer registration is currently closed. Please check back later or contact us for more information."
      );
      return;
    }
    go(pathId);
  }

  return (
    <div className="space-y-4">
      {/* Logo + Sprite (overlapping) */}
      <div className="relative mx-auto w-[340px] max-w-full">
        <img
          src="/images/rainforest-falls-logo-bottom.png"
          alt="Rainforest Falls"
          className="block w-full select-none"
          draggable={false}
        />

        {/* Sprite OVER the logo */}
        <div className="absolute left-1/2 -translate-x-1/2" style={{ top: "2px" }}>
          <ArchSprite
            spriteUrl="/images/animated-arch-sprite.png"
            frameCount={24}
            frameWidth={396}
            frameHeight={364}
            fps={12}
          />
        </div>
      </div>

      {!REGISTRATION_OPEN ? (
        <div className="rounded-xl bg-white/90 p-6 ring-1 ring-slate-200 text-center space-y-4">
          {/* Thank you card when registration is closed */}
          <h1 className="text-2xl font-bold text-slate-800">Registration is Closed</h1>
          <p className="text-base text-slate-700">
            Thank you for your interest! <br />Registration for Calimesa VBS is now closed.
          </p>
          <p className="text-lg font-semibold text-blue-700 mt-2">
            {isAfterCutoff
              ? "We look forward to seeing you next year!"
              : "We look forward to seeing you for the rest of the week!"}
          </p>
        </div>
      ) : (
        <>
          {/* White title card */}
          <header className="rounded-xl bg-white/90 p-4 ring-1 ring-slate-200">
            <h1 className="text-xl font-bold">Calimesa VBS Registration</h1>
            <p className="mt-1 text-sm text-slate-700">
              Choose your registration path to get started.
            </p>
          </header>

          {/* Event Schedule Info */}
          <div className="rounded-xl bg-blue-50 border border-blue-200 p-4 space-y-2">
            <div className="text-sm font-semibold text-blue-900">📅 Event Dates & Times</div>
            <div className="text-sm text-blue-800 space-y-1">
              <div>
                <strong>{vbsSchedule.mainEvent.name}:</strong> {vbsSchedule.mainEvent.dates}
              </div>
              <div className="ml-4 text-xs text-blue-700">{vbsSchedule.mainEvent.time}</div>
              <div>
                <strong>{vbsSchedule.saturdayProgram.name}:</strong> {vbsSchedule.saturdayProgram.date}
              </div>
              <div className="ml-4 text-xs text-blue-700">{vbsSchedule.saturdayProgram.time}</div>
            </div>
          </div>

          <div className="rounded-xl bg-white/90 p-4 ring-1 ring-slate-200 space-y-3">
            <Button className="w-full" variant="secondary" onClick={() => go("parentChild")}>
              Register My Child
            </Button>
            <Button
              className={`w-full ${!VOLUNTEER_REGISTRATION_OPEN ? "opacity-60 cursor-not-allowed" : ""
                }`}
              variant="secondary"
              onClick={() => handleVolunteerClick("volunteerAndChild")}
              aria-disabled={!VOLUNTEER_REGISTRATION_OPEN}
            >
              Volunteer & Register a Child
            </Button>

            <Button
              className={`w-full ${!VOLUNTEER_REGISTRATION_OPEN ? "opacity-60 cursor-not-allowed" : ""
                }`}
              variant="secondary"
              onClick={() => handleVolunteerClick("volunteerOnly")}
              aria-disabled={!VOLUNTEER_REGISTRATION_OPEN}
            >
              Volunteer Only
            </Button>
            {volunteerMessage && (
              <div className="rounded-lg bg-yellow-50 p-3 text-sm text-yellow-800 ring-1 ring-yellow-200">
                {volunteerMessage}
              </div>
            )}
          </div>
        </>
      )}

      <p className="text-xs text-white/40 text-center">v{require('../../package.json').version} Daniel Price</p>
    </div>
  );
}
